
export default {
  singleLabel: "Groupe d'agences",
  storeNamespace: 'agency_group',
  authFeature: 'agencygroup',
  listRouteName: "AgencyGroupList",
  newRouteName: "AgencyGroupNew",
  editRouteName: "AgencyGroupEdit",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'AgencyGroupForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: 'name',
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'im_control',
      label: "Entreprises soumises au contrôle des IM",
      type: 'yesno',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'calibration_periodicity',
      label: "Périodicité d'étalonnage / Contrôle obligatoire (jours)",
      type: 'number',
      inForm: true,
    },
    {
      name: 'calibration_periodicity',
      label: "Périodicité d'étalonnage / Contrôle obligatoire",
      type: 'number',
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value + ' jours' : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/AgencyGroup/config.js